exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.notification-read[data-v-c37d070e] {\n    opacity: 0.3;\n}\n", ""]);

// exports
